export function mapDrugs(drugResultsArray) {
    return drugResultsArray.map((drug) => {
        return {
            title: drug.drugName,
            guideline: drug.guideline,
            summary: drug.fullText?.split(" - ")[1],
            url: drug.url,
        };
    });
}
